<template>
  <div @click="onItemClick" @mouseout="outStyle"
       @mouseover="selectStyle" style="display: flex;align-items: center;margin-left:10px;margin-right: 10px">
    <img :class="{'around-style':isAnimate}" :src="getMenuPic"
         class="left-image-style"/>
    <span :class="{'left-text-style-hover':isActive}" :style="colorstyle"
          class="fz-12 left-text-style">{{content}}</span>
  </div>
</template>

<script>
export default {
  name: 'MenuButtom',
  props: {
    content: String,
    picdata: Object,
    isAnimate: {
      type: Boolean,
      default: false
    },
    allblue: {
      type: Boolean,
      default: false
    },
    colorstyle: {
      type: String,
      default: ''
    }
  },
  watch: {
    allblue (newValue, oldValue) {
      if (newValue) {
        this.isActive = true
      }
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    getMenuPic () {
      return this.isActive ? this.picdata.unselected : this.picdata.selected
    }
  },
  mounted () {
    if (this.allblue) {
      this.isActive = true
    }
  },
  methods: {
    selectStyle () {
      this.isActive = true
    },
    outStyle () {
      if (!this.allblue) {
        this.isActive = false
      } else {
        this.isActive = true
      }

    },
    onItemClick (event) {
      this.$emit('menuitemclick', event)
    }
  }
}

</script>

<style lang="scss" scoped>
  .left-text-style {
    color: black;
    cursor: pointer;
    white-space: nowrap;
  }

  .left-text-style-hover {
    color: blue;
  }

  .left-image-style {
    width: 28px;
    height: 28px;
    margin-right: 10px;
    cursor: pointer;
  }

  .around-style {
    animation: myfirst 1s linear 0s infinite normal;
  }

  @keyframes myfirst {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(720deg);
    }
  }

</style>
